import { motion } from 'framer-motion';
import { Box } from '@mui/material';

interface AccordionProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  isDesktop?: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

export const Accordion: React.FC<AccordionProps> = ({
  trigger,
  children,
  isDesktop = false,
  isOpen,
  onToggle,
}) => {
  return (
    <Box>
      <Box
        onClick={!isDesktop ? onToggle : undefined}
        sx={{
          cursor: !isDesktop ? 'pointer' : 'default',
          userSelect: 'none',
        }}
      >
        {trigger}
      </Box>

      <motion.div
        initial={false}
        animate={{ height: isDesktop || isOpen ? 'auto' : 0 }}
        style={{ overflow: 'hidden' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <Box>{children}</Box>
      </motion.div>
    </Box>
  );
};
